import { Link } from "react-router-dom";
import {
  Home, Wrench, Ruler, ThermometerSun, Sparkles, ShieldCheck, Building2,
  Droplets, PaintRoller, Brush, Award, Users, MapPin, HeartHandshake,
  FileText, PhoneCall, Star,
} from "lucide-react";
import { trackEvent } from "../lib/api";

export const ICONS = {
  Home, Wrench, Ruler, ThermometerSun, Sparkles, ShieldCheck, Building2,
  Droplets, PaintRoller, Brush, Award, Users, MapPin, HeartHandshake,
};

export function Icon({ name, className }) {
  const Cmp = ICONS[name] || Home;
  return <Cmp className={className} />;
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`inline-block text-xs uppercase tracking-[0.22em] font-semibold text-terracotta-600 ${className}`}>
      {children}
    </span>
  );
}

export function SectionHeading({ overline, title, subtitle, center = false, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} ${className}`}>
      {overline && <Overline className="mb-3">{overline}</Overline>}
      <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-neutral-900 text-balance">{title}</h2>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-neutral-700">{subtitle}</p>}
    </div>
  );
}

export function Stars({ n = 5 }) {
  return (
    <div className="flex gap-0.5 text-terracotta-500">
      {Array.from({ length: n }).map((_, i) => (
        <Star key={i} className="h-4 w-4 fill-current" />
      ))}
    </div>
  );
}

export function CTABand() {
  return (
    <section className="relative overflow-hidden bg-vegetal-600">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_20%_20%,white,transparent_40%)]" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20 text-center">
        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white text-balance">
          Un projet pour votre toiture ou votre façade ?
        </h2>
        <p className="mt-4 text-vegetal-50/90 max-w-xl mx-auto">
          Recevez un devis gratuit et sans engagement, ou faites-vous rappeler par un artisan proche de chez vous.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/devis"
            data-testid="ctaband-devis-button"
            onClick={() => trackEvent("cta", "Bandeau CTA - Devis")}
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-terracotta-500 text-white hover:bg-terracotta-600 transition-colors font-medium shadow-sm"
          >
            <FileText className="h-4 w-4" /> Demander un devis gratuit
          </Link>
          <Link
            to="/rappel"
            data-testid="ctaband-rappel-button"
            onClick={() => trackEvent("cta", "Bandeau CTA - Être rappelé")}
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-white text-vegetal-700 hover:bg-vegetal-50 transition-colors font-medium"
          >
            <PhoneCall className="h-4 w-4" /> Être rappelé
          </Link>
        </div>
      </div>
    </section>
  );
}
